export enum FacilityPageTab {
  Overview = "oversikt",
  Separators = "objekt",
  Assignments = "uppdrag",
  // Kundportal = "kundportal",
}
